import axios, { AxiosResponse } from 'axios';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

import { con } from '../../../application/entity/Rutas';

export class SVCDatosPersonales {
    public static async ObtieneDatosPersonales(
        rut: number,
        pasaporte: string,
        codigoNegocio: number,
        tipoPersona: number,
        idPeriodo: number,
        headers: any
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + 'GetDatosPostulantesPorRut';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        const params = {
            rut: rut,
            pasaporte: pasaporte,
            codigoNegocio: codigoNegocio,
            tipoPersona: tipoPersona,
            idPeriodo: idPeriodo,
        }

        await axios
            .get(url, {
                headers,
                params
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async GrabarDatosPersonales(
        headers: any,
        idPersona: number,
        run: string,
        pasaporte: string,
        nombres: string,
        primerApellido: string,
        segundoApellido: string,
        fechaNacimiento: Date,
        codigoComuna: number,
        nombreComuna: string,
        direccion: string,
        telefono: number,
        email: string,
        codSexo: number,
        sexo: string,
        idPais: number,
        pais: string,
        idNacionalidad: number,
        nacionalidad: string,
        rutAlumno: number,
        codigoNegocio: number,
        codigoPrograma: string,
        anioPromocion: number,
        periodoPromocion: number,
        codigoPlanificacion: number,
        tipoPersona: number,
        usuario: string
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + 'PostDatosPersonalesPorAlumno';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .post(url, {
                idPersona: idPersona,
                run: run,
                pasaporte: pasaporte,
                nombres: nombres,
                primerApellido: primerApellido,
                segundoApellido: segundoApellido,
                fechaNacimiento: fechaNacimiento,
                codigoComuna: codigoComuna,
                nombreComuna: nombreComuna,
                direccion: direccion,
                telefono: telefono,
                email: email,
                codSexo: codSexo,
                sexo: sexo,
                idPais: idPais,
                pais: pais,
                idNacionalidad: idNacionalidad,
                nacionalidad: nacionalidad,
                rutAlumno: rutAlumno,
                codigoNegocio: codigoNegocio,
                codigoPrograma: codigoPrograma,
                anioPromocion: anioPromocion,
                periodoPromocion: periodoPromocion,
                codigoPlanificacion: codigoPlanificacion,
                tipoPersona: tipoPersona,
                usuario: usuario,
            }, { headers })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });
        return sr;
    }

    public static async ObtieneDatosTipoPersonaPorPostulacion(
        headers: any,
        rutAlumno: number,
        codigoNegocio: number,
        codigoPrograma: string,
        anioPromocion: number,
        periodoPromocion: number,
        codigoPlanificacion: number,
        tipoPersona: number,
        idPeriodo: number = 0,
        idRefirma: number = 0
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + 'GetPersonaPorPostulacionYTipoPersona';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';
        await axios
            .get(url, {
                headers,
                params: {
                    rutAlumno: rutAlumno,
                    codigoNegocio: codigoNegocio,
                    codigoPrograma: codigoPrograma,
                    anioPromocion: anioPromocion,
                    periodoPromocion: periodoPromocion,
                    codigoPlanificacion: codigoPlanificacion,
                    tipoPersona: tipoPersona,
                    idPeriodo: idPeriodo,
                    idRefirma: idRefirma
                },
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async BloqueoPorRut(
        rutAlumno: number,
        codigoNegocio: number,
        codigoPrograma: string,
        anioPromocion: number,
        periodoPromocion: number,
        codigoPlanificacion: number,
        rutPersona: number,
    ): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + 'AlumnoPostulacion/getBloqueoPorRut';
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = 'Inicializando invocación';

        await axios
            .get(url, {
                params: {
                    rutAlumno: rutAlumno,
                    codigoNegocio: codigoNegocio,
                    codigoPrograma: codigoPrograma,
                    anioPromocion: anioPromocion,
                    periodoPromocion: periodoPromocion,
                    codigoPlanificacion: codigoPlanificacion,
                    rutPersona: rutPersona,
                },
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });
        return sr;
    }
}
